module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-switcher"
  }, [_c('a', {
    staticClass: "link language-switcher-link",
    class: [_vm.$i18n.locale === 'cn' ? 'active' : ''],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLocale('cn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.locale.cn')))]), _vm._v(" "), _c('a', {
    staticClass: "link language-switcher-link",
    class: [_vm.$i18n.locale === 'en' ? 'active' : ''],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLocale('en')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.locale.en')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b37cb64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LandingHeader/LanguageSwitcher.vue
// module id = 632
// module chunks = 1